import { IconTypes } from 'components';
import { IEmployerState } from 'store/types';
import { IEmployerSite, PayoutMethodTypes, PermissionType } from 'types';

export enum MakePaymentStep {
  SelectSite = 'selectSite',
  SelectPayees = 'selectPayees',
  UploadPayment = 'uploadPayment',
  PaymentInput = 'paymentInput',
  PaymentReview = 'paymentReview',
  PaymentSummary = 'paymentSummary',
}

export interface MakePaymentProps {
  balance: number;
  multiSiteUser?: boolean;
  sidebarOpen?: boolean; // for mobile sidebar
  currentEmployeeSites: IEmployerSite[];
  currentSite: IEmployerSite;
  currentSiteId: string;
  pageHeaderContent: React.ReactNode;
  currentOrganization?: IEmployerState;
  currentOrganizationId?: string;
}

export interface MakePaymentSidebarProps {
  onExpand?: () => void;
  onNext?: () => void;
  onBack?: () => void;
}

export interface PayoutMethodOption {
  type: PayoutMethodTypes;
  desc: string;
  icon: IconTypes;
  permission: PermissionType;
}

export const payoutMethodOptions: PayoutMethodOption[] = [
  {
    type: PayoutMethodTypes.STANDARD,
    desc: 'Make a payment manually by adding your employees and their tip amounts.',
    icon: 'CustomDial',
    permission: PermissionType.PAYMENT_CREATE_STANDARD,
  },
  {
    type: PayoutMethodTypes.UPLOAD,
    desc: 'Upload a CSV file to make payments.',
    icon: 'Upload',
    permission: PermissionType.PAYMENT_CREATE_UPLOAD,
  },
  {
    type: PayoutMethodTypes.CALCULATOR,
    desc: 'Make payments with this site’s tip calculation policy.',
    icon: 'Calculator',
    permission: PermissionType.PAYMENT_CREATE_CALCULATOR,
  },
];
